<template>
  <div class="home">
    <div class="bg-box">
      <img src="../../images/home/home-bg-01.jpg" alt="" />
    </div>
    <div class="header-box" v-if="!isQianKun">
      <div class="width-1200">
        <div class="header display-flex align-center justify-between">
          <div class="display-flex align-center flex-1">
            <img
              src="https://ali-file-cdn.iol8.com/img/logo/pe/iol8-pe_372-96.png"
              width="186"
              style="flex: 0 0 186px"
              class="cursor-pointer"
              @click="toHome"
            />
            <nav-view class="flex-1"></nav-view>
          </div>

          <div class="flex-align-center" style="flex: 0 0 260px">
            <a-button class="dashboar-btn" @click="toDashboardFunc">
              我的工作台
            </a-button>
            <div v-if="!hasElectronApi">
              <!-- 已登录 -->
              <div class="color-fff flex-align-center" v-if="userCasId">
                <div class="msg-box" @click="toTspMsgFunc">
                  <img
                    src="../../images/home/img-msg.png"
                    alt=""
                    width="18"
                    height="18"
                  />
                  <div
                    class="red-dot twinkling"
                    v-if="orderUnreadCount > 0"
                  ></div>
                </div>
                <NavigateDrop />
              </div>
              <!-- 未登录 -->
              <div v-else>
                <a-config-provider :autoInsertSpaceInButton="false">
                  <a-button
                    class="margin-lr-10 com-btn"
                    @click="handleRegister"
                  >
                    注册
                  </a-button>
                  <a-button type="primary" class="com-btn" @click="handleLogin">
                    登录
                  </a-button>
                </a-config-provider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="width-1200">
      <div
        class="content margin-b-24"
        :class="!hasElectronApi && 'margin-t-30'"
      >
        <div class="title-img-box">
          <img
            class="logo-02"
            src="../../images/home/home-logo-02.png"
            width="480"
          />
          <img
            class="logo-03"
            src="../../images/home/home-logo-03.png"
            width="180"
          />
        </div>
        <!-- <a-divider style="border-color: #ddd" dashed>常用工具</a-divider> -->

        <a-row :gutter="20" class="padding-t-24 margin-t-60">
          <!-- 术语语料库 -->
          <a-col :span="6" v-if="false">
            <div
              class="comm-item term-coups cursor-pointer"
              @click="termCorpusFunc"
            >
              <img src="../../images/home/comm-icon5.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">术语语料库</p>
              <p class="sub font-size-14">云端管理术语语料库</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 术语提取 -->
          <a-col :span="6">
            <div
              class="comm-item term cursor-pointer"
              @click="termExtractionFunc"
            >
              <img src="../../images/home/comm-icon1.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">译前术语提取</p>
              <p class="sub font-size-14">自动从原稿中提取术语原文</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 网文稿件拆分/合并 -->
          <a-col :span="6" v-if="false">
            <div class="comm-item split cursor-pointer" @click="novelSplitFunc">
              <img src="../../images/home/comm-icon2.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">
                网文稿件拆分/合并
              </p>
              <p class="sub font-size-14">网文拆分/合并一键搞定</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 双语术语挖掘 -->
          <a-col :span="6">
            <div
              class="comm-item cursor-pointer"
              @click="handlerToBilingualTermMiningPage"
            >
              <img
                src="../../images/home/bilingual-term-mining.png"
                width="56"
              />
              <p class="font-size-16 color-333 font-weight-600">双语术语挖掘</p>
              <p class="sub font-size-14">AI挖掘成对双语术语</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 语料对齐 -->
          <a-col :span="6">
            <div
              class="comm-item align cursor-pointer"
              @click="corpusAlignmentFunc"
            >
              <img src="../../images/home/comm-icon4.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">语料对齐</p>
              <p class="sub font-size-14">上传原译文自动获取语料</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 字数换算 -->
          <a-col :span="6">
            <div
              class="comm-item count cursor-pointer"
              @click="handlerToCountPage"
            >
              <img src="../../images/home/comm-icon3.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">字数换算</p>
              <p class="sub font-size-14">根据系数对不同语言字数换算</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 字数统计 -->
          <a-col :span="6" v-if="isElectronAndHasApi()">
            <div
              class="comm-item word-count cursor-pointer margin-t-50"
              @click="handlerToWordCountPage"
            >
              <img src="../../images/home/word-count.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">字数统计</p>
              <p class="sub font-size-14">快速统计稿件字数</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 文件合并/拆分 -->
          <a-col :span="6" v-if="isElectronAndHasApi() && false">
            <div
              class="comm-item split-and-merge cursor-pointer margin-t-50"
              @click="handlerToSplitAndMergePage"
            >
              <img src="../../images/home/split-and-merge.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">
                文件合并/拆分
              </p>
              <p class="sub font-size-14">让文件处理会更加灵活</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 文件格式转换 -->
          <a-col :span="6" v-if="false">
            <div
              class="comm-item tool-change-excel cursor-pointer margin-t-50"
              @click="handlerToToolChangeExcelPage"
            >
              <img src="../../images/home/tool-change-excel.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">文件格式转换</p>
              <p class="sub font-size-14">支持多种格式文件转换为Excel</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- TransGPT -->
          <a-col v-if="false" :span="6">
            <div
              class="comm-item cursor-pointer margin-t-50 relative"
              @click="handlerToTransGPTPage"
            >
              <img src="../../images/home/transGPT-img.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">TransGPT</p>
              <p class="sub font-size-14">AI译文润色、提取术语、翻译</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
              <div class="tips-box">
                <span>•</span>
                <span class="margin-l-5">暂停使用</span>
              </div>
            </div>
          </a-col>

          <!-- 视频音频分离 -->
          <a-col :span="6" v-if="userCasId && hascasId">
            <div
              class="comm-item cursor-pointer margin-t-50"
              @click="toVideoFunc('audioVideoSeparation')"
            >
              <img src="../../images/home/fl.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">视频音频分离</p>
              <p class="sub font-size-14">自动从视频中将视频和音频分离</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 人声和背景音分离  -->
          <a-col :span="6" v-if="userCasId && hascasId">
            <div
              class="comm-item cursor-pointer margin-t-50"
              @click="toVideoFunc('soundSeparation')"
            >
              <img src="../../images/home/rs.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">
                人声和背景音分离
              </p>
              <p class="sub font-size-14">自动从音频文件中的人声和背景音分离</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 听录转写字幕  -->
          <a-col :span="6" v-if="userCasId && hascasId">
            <div
              class="comm-item cursor-pointer margin-t-50"
              @click="toVideoFunc('listenTranscribewrite')"
            >
              <img src="../../images/home/zx.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">听录转写字幕</p>
              <p class="sub font-size-14">将音频转写成字幕srt文件</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 字幕翻译  -->
          <a-col :span="6" v-if="userCasId && hascasId">
            <div
              class="comm-item cursor-pointer margin-t-50"
              @click="toVideoFunc('srtTranslate')"
            >
              <img src="../../images/home/fy.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">字幕翻译</p>
              <p class="sub font-size-14">srt字幕翻译，使用GPT控制译文长度</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 字幕配音  -->
          <a-col :span="6" v-if="userCasId && hascasId">
            <div
              class="comm-item cursor-pointer margin-t-50"
              @click="toVideoFunc('srtSpeech')"
            >
              <img src="../../images/home/py.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">字幕配音</p>
              <p class="sub font-size-14">使用预置AI声纹为字幕提供配音</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>

          <!-- 视频音频合成 -->
          <a-col :span="6" v-if="userCasId && hascasId">
            <div
              class="comm-item cursor-pointer margin-t-50"
              @click="toVideoFunc('videoSynthesis')"
            >
              <img src="../../images/home/spyp.png" width="56" />
              <p class="font-size-16 color-333 font-weight-600">视频音频合成</p>
              <p class="sub font-size-14">自动将无声视频和音频合成为有声视频</p>
              <img
                class="term-pic"
                src="../../images/home/home-content-01.png"
                alt=""
                width="42"
              />
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="footer margin-t-40">
      <div class="width-1200 flex-center">
        <img src="../../images/home/home-footer-01.png" alt="" width="16" />
        <span class="font-size-14 color-fff padding-l-10">
          更多实用工具正在研发中，敬请期待
        </span>
      </div>
    </div>
  </div>
  <!-- 下载客户端提示 -->
  <down-load-modal v-model:visible="visible"></down-load-modal>
</template>

<script>
  import { reactive, toRefs, computed, onUnmounted, onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import { useStore } from 'vuex'
  import { ToolFilled } from '@ant-design/icons-vue'
  import { getTicket, getUserInfo, countMessage } from '../../http/api'
  import useUtils from '../../utils/useUtils'
  import DownLoadModal from './modal/downLoad.vue'
  import NavigateDrop from '../../components/header/navigateDrop.vue'
  import NavView from './component/nav.vue'

  import { trackStatistics } from '@/utils/tracker/index'
  import { trackMap } from '@/utils/tracker/trackData'

  export default {
    name: 'home',
    components: {
      ToolFilled,
      DownLoadModal,
      NavigateDrop,
      NavView,
    },
    setup() {
      const router = useRouter()
      const store = useStore()
      const {
        hasElectronApiHandler,
        isElectronHandler,
        hasOpenWordCountApiHandler,
        hasOpenSplitAndMergeApiHandler,
        hasOpenToolChangeExcelApiHandler,
        isQianKunFunc,
      } = useUtils()

      const data = reactive({
        visible: false,
        orderUnreadCount: 0,
        toolUnreadCount: 0,
        clearIntervalTime: null,
      })

      const userCasId = computed(() => store.state.comm.userInfo.id)
      const hascasId = computed(() => {
        const casId = store.state.comm.userInfo.id
        const arr = [
          'cc43u5s0cbdfmpoeugn0',
          'c8bg3m39ano5ppmmn8ig',
          'c8bg8b39ano5ppmmn8m0',
          'cau08f1rrtbujhren63g',
          'cbu58hhdi25drlujq6qg',
          'cgbtbv40cbdfj9shqa80',
          'cgbtlii6j4uvam1uvjr0',
          'cgbravk0cbdfj9shq8rg',
          'caugdrhrrtbujhrenm7g',
          'ckjlns4m115on7hskic0',
          'ck1a6duc1943slnilerg',
          'c29p60ui21psb4j3lcv0',
          'c2jmps6i21pqgmorbgtg',
          'c652hdj9ano2nl7vqdhg',
          'c2d465ei21pqgmor99og', // steven的生产账号
        ]
        return arr.includes(casId)
      })

      // 注册
      const handleRegister = () => {
        const url = encodeURIComponent(location.href)
        window.location.href =
          window.location.origin + '/go/passport_pc/register?service=' + url
      }

      // 登录
      const handleLogin = () => {
        const url = encodeURIComponent(location.href)
        window.location.href =
          window.location.origin + '/go/passport_pc/cas/login?service=' + url
      }

      // 术语语料库
      const termCorpusFunc = async () => {
        const newWindow = window.open()
        const { ticket } = await getTicket({})
        let url =
          window.location.origin + `/go/termcorpus_pc/api/v1/redirect/${ticket}`
        newWindow.location = url
      }

      // 术语提取
      const termExtractionFunc = () => {
        router.push({
          path: '/termExtraction',
        })
      }

      // 网文稿件拆分/合并
      const novelSplitFunc = () => {
        router.push({
          path: '/novelSplit',
        })
      }

      // 语料对齐
      const corpusAlignmentFunc = () => {
        router.push({
          path: '/corpusAlignment',
        })
      }

      // 字数计算器
      const handlerToCountPage = () => {
        router.push({
          path: '/countCalculator',
        })
      }

      // 字数统计
      const handlerToWordCountPage = () => {
        if (hasOpenWordCountApiHandler()) {
          window.electronApi.openWordCount()
        } else {
          data.visible = true
        }
      }

      // 文件拆分合并
      const handlerToSplitAndMergePage = () => {
        if (hasOpenSplitAndMergeApiHandler()) {
          window.electronApi.openSplitAndMerge()
        } else {
          data.visible = true
        }
      }

      // 工具转换Excel
      const handlerToToolChangeExcelPage = () => {
        if (hasOpenToolChangeExcelApiHandler()) {
          window.electronApi.openToolChangeExcel()
        } else {
          data.visible = true
        }
      }

      // 双语术语挖掘
      const handlerToBilingualTermMiningPage = () => {
        router.push({
          path: '/bilingualTermMining',
        })
      }

      const handlerToTransGPTPage = () => {
        router.push({
          path: '/transGPT',
        })
      }

      // 有没有electronApi
      const isElectronAndHasApi = () => {
        const flag = window.electronApi ? true : false
        return flag
      }

      const toHome = () => {
        window.open('/go/tsp_pc_login_option/home', '_blank')
      }

      // 我的工作台
      const toDashboardFunc = () => {
        trackStatistics({
          event_code: 'topNavigation',
          scene_code: trackMap['tsp-dashboard'] || '',
        })
        window.open('/go/tsp_pc_login/dashboard', '_blank')
      }

      // 工具消息
      const toTspMsgFunc = () => {
        trackStatistics({
          event_code: 'topNavigation',
          scene_code: trackMap['wd-message'] || '',
        })
        window.open('/go/tsp_pc_login_option/home?openIm=1', '_blank')
      }

      const countMessageFunc = () => {
        countMessage().then((res) => {
          data.orderUnreadCount = res?.orderUnreadCount || 0
          data.toolUnreadCount = res?.toolUnreadCount || 0
        })
      }

      // 请求是否有未读消息
      const readMsgFunc = () => {
        data.clearIntervalTime = setInterval(() => {
          countMessageFunc()
        }, 30000)
        countMessageFunc()
      }

      // 前往AI音频页面
      const toVideoFunc = (page) => {
        router.push({
          path: '/video',
          query: {
            page,
          },
        })
      }

      onMounted(() => {
        readMsgFunc()
        getUserInfo({ token: localStorage.token }).then((res) => {
          if (!res.id) {
            localStorage.token = ''
            localStorage.userInfo = ''
            store.commit('comm/changeKey', { token: '' })
            store.commit('comm/changeKey', { userInfo: '' })
          } else {
            localStorage.userInfo = JSON.stringify(res)
            store.commit('comm/changeKey', { userInfo: res })
          }
        })
      })

      // 清除延时器
      onUnmounted(() => {
        clearInterval(data.clearIntervalTime)
      })

      return {
        ...toRefs(data),
        userCasId,
        hasElectronApi: hasElectronApiHandler(),
        isQianKun: isQianKunFunc(),
        router,
        hascasId,
        termCorpusFunc,
        handleRegister,
        handleLogin,
        termExtractionFunc,
        novelSplitFunc,
        corpusAlignmentFunc,
        handlerToCountPage,
        handlerToWordCountPage,
        handlerToSplitAndMergePage,
        handlerToToolChangeExcelPage,
        handlerToBilingualTermMiningPage,
        handlerToTransGPTPage,
        isElectronAndHasApi,
        toHome,
        toDashboardFunc,
        toTspMsgFunc,
        toVideoFunc,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .home {
    overflow-y: auto;
    width: 100%;
    background-color: #f5f9ff;
    position: relative;
    z-index: 1;
    .header-box {
      position: relative;
      z-index: 4;
      background: rgba(255, 255, 255, 0.8);
    }
    .bg-box {
      position: absolute;
      top: 0;
      left: 0;
      height: 600px;
      width: 100%;
      z-index: 2;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .header {
      height: 72px;
      .button {
        padding: 5px 10px;
        font-size: 15px;
        color: #000000;
        cursor: pointer;
        &:hover {
          background: #ebf4ff;
          border-radius: 6px;
        }
      }
    }
    .content {
      position: relative;
      z-index: 3;
      min-height: calc(100vh - 176px);
      text-align: center;
      .comm-item {
        position: relative;
        padding: 30px 20px;
        border-radius: 10px;
        text-align: left;
        transition: all 0.3s;
        background: linear-gradient(
          90deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0.5) 100%
        );
        box-shadow: 0px 10px 20px 0px rgba(39, 134, 255, 0.1);
        &:hover {
          transform: scale(1.05);
          .term-pic {
            display: block;
          }
        }
        img {
          margin-top: -64px;
        }
        .sub {
          color: #999;
        }
        .term-pic {
          display: none;
          position: absolute;
          top: 96px;
          right: 20px;
        }
      }
      .more-item {
        text-align: left;
        .more-item-content {
          flex: auto;
          .sub {
            color: rgba($color: #000, $alpha: 0.4);
          }
        }
      }
      .banner {
        width: 100%;
        height: 200px;
        background: #ebf4ff;
        border-radius: 10px;
        .banner-img {
          flex: 1;
          text-align: right;
        }
        .banner-content {
          margin-left: 50px;
          flex: 1;
          text-align: left;
          height: 100%;
          flex-direction: column;
        }
      }
    }
    .footer {
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: linear-gradient(
        241deg,
        #9fc9ff 0%,
        #c9e1ff 34%,
        #1f82ff 100%
      );
    }
  }
  .exit-box {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    &:hover {
      background: rgba(39, 134, 255, 0.1);
      cursor: pointer;
      .anticon {
        color: #2786ff !important;
      }
    }
  }
  .avatar-box {
    width: 36px;
    height: 36px;
    border-radius: 50%;
  }
  .com-btn {
    :deep(.ant-btn-primary) {
      text-shadow: none;
      box-shadow: none;
    }
  }
  :deep(.ant-btn) {
    height: 36px;
  }
  .title-img-box {
    width: 480px;
    height: 230px;
    position: relative;
    .logo-02 {
      margin-left: 110px;
      margin-top: 20px;
    }
    .logo-03 {
      position: absolute;
      left: 110px;
      top: 20px;
    }
  }
  .dropdown-box {
    margin-top: 14px;
    padding: 30px;
    background: #ffffff;
    box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    border: 1px solid #f2f3f5;
  }
  .msg-box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin-left: 20px;
    margin-right: 20px;
    cursor: pointer;
    img {
      display: block;
    }
    &:hover {
      background-color: #f2f3f5;
      border-radius: 6px;
    }
  }
  .msg-item {
    width: 140px;
    height: 48px;
    background: #fff;
    cursor: pointer;
    &:hover {
      background: #f2f3f5;
      border-radius: 8px;
    }
  }
  .msg-num {
    height: 16px;
    line-height: 16px;
    padding: 0 4px;
    font-weight: 600;
    color: #ffffff;
    font-size: 12px;
    background: #f55c3f;
    margin-left: 14px;
    border-radius: 8px;
  }
  .text-1c2129 {
    color: #1c2129;
  }
  .tips-box {
    position: absolute;
    top: 16px;
    right: 20px;
    font-size: 14px;
    color: #c9cdd4;
  }
  .dashboar-btn {
    width: 118px;
    height: 36px;
    border-radius: 6px;
  }
  .twinkling {
    -webkit-animation: action 0.8s infinite;
    -moz-animation: action 0.8s infinite;
    animation: action 0.8s infinite;
  }
  .red-dot {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #f55c3f;
  }
  @keyframes action {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-webkit-keyframes action {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
